import { GEO_TYPES } from 'src/features/parkingManagement/types/parking';
import { parkingManagementMessages } from 'src/features/parkingManagement/utils/messages';

export const geoTypeOptions = [
    { label: parkingManagementMessages.geoTypePoint, value: GEO_TYPES.POINT },
    { label: parkingManagementMessages.geoTypeArea, value: GEO_TYPES.AREA },
];
